import { startLoading, endLoading } from "../progress/pogressSlice";
import { serverErrors } from "../";
import * as api from "../../api";

const eventsYear = `events/report/year`;

const eventAttendance = `events/attendance/year`;

export const report = async (path, dispatch, setData, setStatus) => {
    try {
        dispatch(startLoading())
        const { data } = await api.getReport(path)
        dispatch(endLoading())
        setStatus('succeeded')
        return setData(data);
    } catch (error) {
        console.log(error);
        setStatus('succeeded')
        return dispatch(serverErrors(error, endLoading))
    }
}

export const reportByYear = async (dispatch, setData, setStatus) => {
    try {
        dispatch(startLoading())
        const { data } = await api.getData(eventsYear)
        dispatch(endLoading())
        setStatus('succeeded')
        return setData(data);
    } catch (error) {
        console.log(error);
        setStatus('succeeded')
        return dispatch(serverErrors(error, endLoading))
    }
}

export const reportStudents = async (type, dispatch, setData) => {
    try {
        dispatch(startLoading())
        const { data } = await api.getData(`students/report/${type}`)
        dispatch(endLoading())
        return setData(data);
    } catch (error) {
        console.log(error);
        return dispatch(serverErrors(error, endLoading))
    }
}

export const reportEvent = async(dispatch, year, setData, setStatus) => {
    dispatch(startLoading());
    try {
        const { data } = await api.getData(`${eventAttendance}/${year}`)
        dispatch(endLoading());
        setStatus('succeeded')
        return setData(data);
    } catch (error) {
        console.log(error);
        return dispatch(serverErrors(error, endLoading))
    }
}